import * as React from "react";
const GoogleIcon = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.6 12.2132C21.6 11.4239 21.5347 10.8479 21.3932 10.2506H12.1959V13.8132H17.5945C17.4857 14.6986 16.898 16.0319 15.5918 16.9279L15.5735 17.0471L18.4815 19.2549L18.683 19.2746C20.5333 17.5999 21.6 15.1359 21.6 12.2132Z"
      fill="#4285F4"
    />
    <path
      d="M12.1959 21.5999C14.8408 21.5999 17.0612 20.7465 18.683 19.2746L15.5918 16.9279C14.7646 17.4932 13.6544 17.8879 12.1959 17.8879C9.60548 17.8879 7.40686 16.2132 6.62311 13.8986L6.50823 13.9081L3.48444 16.2015L3.4449 16.3092C5.05577 19.4452 8.36462 21.5999 12.1959 21.5999Z"
      fill="#34A853"
    />
    <path
      d="M6.62311 13.8986C6.41631 13.3013 6.29663 12.6612 6.29663 11.9999C6.29663 11.3385 6.41631 10.6986 6.61223 10.1012L6.60675 9.97401L3.54507 7.64383L3.4449 7.69053C2.78098 8.99188 2.40002 10.4532 2.40002 11.9999C2.40002 13.5466 2.78098 15.0079 3.4449 16.3092L6.62311 13.8986Z"
      fill="#FBBC05"
    />
    <path
      d="M12.1959 6.11188C14.0354 6.11188 15.2762 6.89054 15.9837 7.54125L18.7483 4.8959C17.0504 3.34924 14.8408 2.3999 12.1959 2.3999C8.36462 2.3999 5.05576 4.55455 3.4449 7.69053L6.61223 10.1012C7.40686 7.78657 9.60548 6.11188 12.1959 6.11188Z"
      fill="#EB4335"
    />
  </svg>
);
export default GoogleIcon;
